import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchMultiSelect } from "components/input/colorSearchMultiSelect/ColorSearchMultiSelect";
import type { Dispatch } from "react";
import { useTranslation } from "react-i18next";
import { getColorEffectValues } from "service/autocomplete-lookup";

export interface ColorEffectFilterProps {
  value: Array<AutocompleteData> | undefined;
  onChange: Dispatch<Array<AutocompleteData>>;
}

export const ColorEffectFilter = ({
  value = [],
  onChange,
}: ColorEffectFilterProps) => {
  const options = getColorEffectValues();
  const { t } = useTranslation();
  return (
    <ColorSearchMultiSelect
      options={options}
      onChange={onChange}
      value={value}
      label={t("filter_color_effect")}
    />
  );
};
